import {
    COMPACT_MAP_OPEN_PARAM,
    COMPACT_MAP_OPEN_VALUE,
    CompactMapRouteParams,
} from '@/features/orders/constants/route-params'
import { useOrderDetailNavigation } from '@/features/orders/hooks/useOrderDetailNavigation'
import { router, useGlobalSearchParams } from 'expo-router'
import { useCallback } from 'react'

export const useCompactMapController = () => {
    const params = useGlobalSearchParams<CompactMapRouteParams>()
    const navigateToOrderDetail = useOrderDetailNavigation()

    const open = useCallback(
        () => router.setParams({ [COMPACT_MAP_OPEN_PARAM]: COMPACT_MAP_OPEN_VALUE }),
        []
    )
    const close = useCallback(() => router.setParams({ [COMPACT_MAP_OPEN_PARAM]: undefined }), [])
    const openOrder = useCallback(
        (id: string) =>
            navigateToOrderDetail(id, {
                [COMPACT_MAP_OPEN_PARAM]: COMPACT_MAP_OPEN_VALUE,
            }),
        [navigateToOrderDetail]
    )

    return {
        isOpen: params[COMPACT_MAP_OPEN_PARAM] === COMPACT_MAP_OPEN_VALUE,
        open,
        close,
        openOrder,
    }
}
